import { render } from "./Sale.vue?vue&type=template&id=99502ed0&scoped=true"
import script from "./Sale.vue?vue&type=script&lang=js"
export * from "./Sale.vue?vue&type=script&lang=js"

import "./Sale.vue?vue&type=style&index=0&id=99502ed0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99502ed0"]])

export default __exports__